import React from 'react';
import { motion } from 'framer-motion';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { journeyImages } from '../../data/tourData';
import './JourneyCarouselSection.css';

const JourneyCarouselSection = () => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % journeyImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + journeyImages.length) % journeyImages.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  React.useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="journey-carousel">
      <div className="container">
        <div className="carousel-header">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Journey In Frames
          </motion.h2>
        </div>
        
        <div className="carousel-container">
          <div className="carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {journeyImages.map((image, index) => (
              <div key={index} className="carousel-slide">
                <img src={image} alt={`Journey Frame ${index + 1}`} />
              </div>
            ))}
          </div>
          
          <button className="carousel-nav carousel-prev" onClick={prevSlide}>
            <FaChevronLeft />
          </button>
          <button className="carousel-nav carousel-next" onClick={nextSlide}>
            <FaChevronRight />
          </button>
          
          <div className="carousel-progress">
            {journeyImages.map((_, index) => (
              <div 
                key={index}
                className={`progress-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneyCarouselSection;
